import React from "react";
import { useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Styles/InfographicSlider.css";
import ComponentPoster from "../../Components/Common/ComponentPoster";

const InfographicSlider = ({
  slides,
  setFirstSlideToggle,
  setSecondSlideToggle,
}) => {
  const [infographicIndex, setInfographicIndex] = useState(0);
  const clickSlide = (i) => {
    setInfographicIndex(i);
  };

  return (
    <Swiper
      slidesPerView={1}
      navigation
      modules={[Navigation]}
      spaceBetween={10}
      className={"InfographicSlider_swiper-wrapper"}
      onSlideChange={(ex) => clickSlide(ex.activeIndex)}
      centeredSlides={true}
      breakpoints={{
        1300: {
          slidesPerView: 1,
        },
        1200: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
      }}
    >
      <SwiperSlide>
        <img
          src="/imgs/Landing/HisstoriInfo1.jpg"
          className="InfographicSlider_Infographic_img"
          onClick={() => setFirstSlideToggle((prev) => !prev)}
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src="/imgs/Landing/HisstoriInfo2.jpg"
          className="InfographicSlider_Infographic_img"
          onClick={() => setSecondSlideToggle((prev) => !prev)}
        />
      </SwiperSlide>
    </Swiper>
  );
};
InfographicSlider.defaultProps = {};
export default InfographicSlider;
